import React, { useContext, useState } from "react";
import API from "../../services/api";
import FavoriteIcon from "@material-ui/icons/Favorite";
import UnFavoriteIcon from "@material-ui/icons/FavoriteBorderOutlined";
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
// import { ReactComponent as CreateNewFolderIcon } from "../../assets/folder1.svg";
import { ReactComponent as GetAppIcon } from "../../assets/download.svg";
// import { ReactComponent as Activedownload } from "../../assets/activedownload.svg";
import { DownloadIcon } from "../NewUI/icons";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import TrackContext from "../../contexts/track-context";
import Helper from "../../services/helper";
import Constants from "../../services/constants";
import { toast } from "react-toastify";
import { ErrorToast, SuccessToast } from "../../pure-components/CustomToast";
import CookieManager from "../../services/CookieManager";
import { CircularProgress } from "@material-ui/core";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import SaveAltOutlinedIcon from '@mui/icons-material/SaveAltOutlined';

function TrackAction(props) {
  let trackContext = useContext(TrackContext);
  const [hdmp3File, setHdmp3File] = useState(false);
  const [originalFile, setOriginalFile] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  // const [favs, setFavs] = useState([]);


  const handleDownloadTrackOld = async (event, trackId) => {
    if (!trackContext.validateUser(Constants.ACTION.DOWNLOAD)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.DOWNLOAD);
      return;
    }
    let currentTarget = event.currentTarget;
    await API.getDownloadTracks(trackId).then((res) => {
      if (res?.audiofile !== undefined && res.audiofile !== null) {
        setHdmp3File(res.audiofile?.hd_mp3.url);
        setOriginalFile(res.audiofile?.original.url);
        setShowDownloadModal(currentTarget);
      } else {
        Helper.handleError(res);
      }
    });

  };

  const handleDownloadTrack = async (event, trackId) => {
    let cachedUserData = JSON.parse(CookieManager.getCookie("user-data"));
    if (!trackContext.validateUser(Constants.ACTION.DOWNLOAD)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.DOWNLOAD);
      return;
    }
      props.setDownloadingTracks([...props.downloadingTracks, trackId])
      const filter = {
        "Identifier": trackId,
        "DownloadType": "track",
        "Format": "mp3",
        "TrimStartSecs": 0,
        "TrimEndSecs": 0,
        "Email": cachedUserData.email,
        "IsShare": false,
        "Message": "",
        "SenderEmail": "",
        "ForceEmail": false,
        "IncludeVersions": false,
        "VersionFolderName": "",
        "DownloadFileName": "",
        "CuesheetFileName": "",
        "IncludeCuesheetFile": false
      }

      await API.downloadTrack(filter).then(resp => {
        if(resp.success){
          toast(({ closeToast }) => <SuccessToast message={"Request processed. Download will begin shortly."} />);
          // console.log("track download resp : ", resp);
          if(resp.data?.DownloadTokens?.length > 0){
            const accessURLs = JSON.parse(localStorage.getItem("resourceURL")|| "{}");
            if(accessURLs?.DirectDownloadURL?.length > 0){
              const downloadURL = accessURLs.DirectDownloadURL.replace("{downloadtoken}", resp.data.DownloadTokens[0].TokenValue)
              const link = document.createElement('a');
              link.href = downloadURL;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          }
        }
        else
          toast(({ closeToast }) => <ErrorToast message={"Track download Error : " + resp.mssg || resp.err} />);
      }).catch(err =>{
        // console.log("Track download error : ", err);
        toast(({ closeToast }) => <ErrorToast message={"Track download Error : " + err.mssg || err} />);
      }).finally(() => {
        const tempData = props.downloadingTracks;
        tempData?.length > 0 && tempData.splice(tempData.indexOf(trackId), 1);
        props.setDownloadingTracks(tempData);
      })
    

  };

  const handleDownloadArchive = (trackId, quality) => {
    API.downloadArchiveTrack(trackId, quality).then((res) => { });
  };

  const handleArchiveDownload = async (trackId, quality) => {
    await API.downloadArchiveTrack(trackId, quality, props.projectId).then(async (res) => {
      if (res) {
        if (props.projectList?.length > 0) {
          let tempProjects = props.projectList.map(element => {
            let tempdata = { ...element };
            if (tempdata?._id === res._id) {
              for (var i = 0; i < tempdata.trackIds.length; i++) {
                tempdata.trackIds[i]["downloadCount"] = res.trackIds[i]?.downloadCount;
              }
              return tempdata;
            }
            return tempdata;
          })
          props.setProjectList(tempProjects);
        }
        await setDownloadHistory(trackId);
        toast(({ closeToast }) => (
          <SuccessToast message="Check your email, you have been sent a link to download the files." />
        ));
      } else {
        toast(({ closeToast }) => <ErrorToast message={res.message} />);
      }
      setShowDownloadModal(false);
    });
  };

  const handleDownloadClick = async (trackId, fileType) => {
    if (fileType === 'original') {
      window.open(originalFile, '_blank');
    } else {
      window.open(hdmp3File, '_blank');
    }
    setShowDownloadModal(false);
    await setProjectTrackDownloadCount(trackId);
    await setDownloadHistory(trackId);
  }

  const setProjectTrackDownloadCount = async (trackId) => {
    if (props.projectId?.length > 0) {
      await API.setProjectTrackDownloadCount(trackId, props.projectId).then((res) => {
        if (props.projectList?.length > 0) {
          let tempProjects = props.projectList.map(element => {
            let tempdata = { ...element };
            if (tempdata?._id === res.data._id) {
              for (var i = 0; i < tempdata.trackIds.length; i++) {
                tempdata.trackIds[i]["downloadCount"] = res.data.trackIds[i]?.downloadCount;
              }
              return tempdata;
            }
            return tempdata;
          })
          props.setProjectList(tempProjects);
        }
      });
    }
  };

  const setDownloadHistory = async (trackId) => {
    await API.setDownloads(trackId).then((res) => {
      const downloadlist = JSON.parse(localStorage.getItem("download"));
      downloadlist.push(trackId);
      props.setDownload(downloadlist);
      localStorage.setItem("download", JSON.stringify(downloadlist));
    });
  };
  const handleClose = () => {
    setShowDownloadModal(false);
  };
  const handleProjectModal = (trackId, projectTrackId) => {
    if (!trackContext.validateUser(Constants.ACTION.ADD_TO_PROJECT)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.ADD_TO_PROJECT);
      return;
    }
    // props.setTrackToBeAddedToProject(trackId);
    // props.setTrackToBeRemoveToProject(projectTrackId);
    // props.setShowProjectModal(true);

    trackContext.setTrackToBeAddedToProject(trackId);
    trackContext.setShowProjectModal(true);

  };

  return (
    <>
      {props.favs?.length > 0 && props.favs.indexOf(props.trackId) !== -1 ? (
        <FavoriteIcon
          onClick={() => props.handleAddTrackToFavorites(props.trackData)}
          style={{ fontSize: "24px"}}
          className="fav-icon self-center sm:right-0 cursor-pointer text-red-600"
        />
      ) : (
        <UnFavoriteIcon
          onClick={() => props.handleAddTrackToFavorites(props.trackData)}
          style={{ fontSize: "24px"}}
          className="trackicon unfav-icon self-center sm:right-0 cursor-pointer text-red-600"
        />
      )}
      <CreateNewFolderOutlinedIcon
        style={{ fontSize: "24px" }}
        onClick={() => handleProjectModal({trackId : props.trackId, albumId : props.trackData?.album?.id, artworkRef : Helper.getArtworkURL(props.trackData?.album?.id), audioRef : Helper.playTrackURL(props.trackId)}, props.projectTrackId)}
        // onClick={() => handleProjectModal(props.trackId, props.projectTrackId)}
        className="w-5 sm:w-8 m-2 mt-2 self-center right-0 cursor-pointer text-gray-700 hover:text-blue-600"
      />
      {props.download.indexOf(props.trackId) !== -1 || props.downloadCount ? (
        props.downloadingTracks?.indexOf(props.trackId) > -1 ? 
        <div className="pt-3 pr-1" ><CircularProgress size='18px'/></div> : 
        <>
          <SaveAltOutlinedIcon
            onClick={(event) => props.handleDownloadClick(event, props.trackId)}
            style={{ fontSize: "24px"}}
            className="self-center cursor-pointer"
          />
          {props.downloadCount && <span className="text-xs mt-1">{props.downloadCount}</span>}
        </>
      ) : (
        props.downloadingTracks?.indexOf(props.trackId) > -1 ? 
        <div className="pt-3 pr-1" ><CircularProgress size='18px'/></div> : 
        <GetAppIcon
          onClick={(event) => props.handleDownloadClick(event, props.trackId)}
          style={{ fontSize: "20px" }}
          className="m-1 self-center right-0 cursor-pointer text-gray-700 hover:text-blue-600"
        />
      )}
      <Menu
        id="customized-menu"
        anchorEl={showDownloadModal}
        open={Boolean(showDownloadModal)}
        onClose={handleClose}
        style={{ width: "320px" }}
      >
        <MenuItem
          onClick={() => handleDownloadClick(props.trackId, "original")}
          className="card-action"
        >
          <span className="card-action-text">
            Original HD - Single track
          </span>
        </MenuItem>
        <MenuItem
          onClick={() => handleArchiveDownload(props.trackId, "original")}
          className="card-action"
        >
          <span className="card-action-text">
            Original HD - All versions
          </span>
        </MenuItem>
        <MenuItem
          onClick={() => handleDownloadClick(props.trackId, "hdMp3")}
          className="card-action"
        >
          <span className="card-action-text">
            MP3 - Single track
          </span>
        </MenuItem>
        <MenuItem
          onClick={() => handleArchiveDownload(props.trackId, "hd_mp3")}
          className="card-action"
        >
          <span className="card-action-text">
            MP3 - All versions
          </span>
        </MenuItem>
      </Menu>
    </>
  );
}

export default TrackAction;